import CitySEOHead from "@/components/feature/CitySEOHead";
import CoralvilleHeroSection from "./components/HeroSection";
import CoralvilleStickyNav from "./components/StickyNav";
import CoralvilleProcessingTimeSection from "./components/ProcessingTimeSection";
import CoralvilleServicesSection from "./components/ServicesSection";
import CoralvilleLocalAreaSection from "./components/LocalAreaSection";
import CoralvilleTestimonialsSection from "./components/TestimonialsSection";
import CoralvilleAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import CoralvilleComparisonSection from "./components/ComparisonSection";
import CoralvilleMistakesSection from "./components/MistakesSection";
import CoralvilleHowItWorksSection from "./components/HowItWorksSection";
import CoralvilleFAQSection, { faqs } from "./components/FAQSection";
import CoralvilleHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import CoralvilleFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const servicesList = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function CoralvillePage() {
  return (
    <>
      <CitySEOHead
        city="Coralville"
        state="Iowa"
        stateAbbr="IA"
        route="/coralville"
        title="Emergency Passport Coralville, IA — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Coralville, IA — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving Iowa River Landing professionals, UIowa travelers, and Johnson County families."
        geoPlacename="Coralville, Iowa"
        geoPosition="41.6764;-91.5807"
        faqs={faqs}
        servicesSchema={servicesList}
        statePageName="Iowa"
        statePageRoute="/states/iowa"
        serviceAreaDesc="Emergency and expedited passport services for Coralville, Iowa River Landing professionals, and Johnson County. As fast as 24 hours."
      />
      <div className="font-sans">
        <CoralvilleHeroSection />
        <CoralvilleStickyNav />
        <CoralvilleProcessingTimeSection />
        <CoralvilleLocalAreaSection />
        <CoralvilleServicesSection />
        <CoralvilleTestimonialsSection />
        <CoralvilleAcceptanceFacilitiesSection />
        <CoralvilleComparisonSection />
        <CoralvilleMistakesSection />
        <CoralvilleHowItWorksSection />
        <CoralvilleFAQSection />
        <CoralvilleHelpfulResourcesSection />
        <SEOCrossLinks currentRoute="/cities/coralville" state="IA" />
        <CoralvilleFinalCTA />
      </div>
    </>
  );
}